import React from 'react';
import WebsiteImage from 'components/WebsiteImage';
import Styles from 'components/Styles';

import { RichTextImageContainer } from './styles';

const RichTextImage = ({
  src,
  justifyDesktop,
  justifyMobile,
  alt,
  boxShadow,
  styles,
  caption,
  imageSizes,
  widthMobile,
  widthDesktop,
  ...otherProps
}) => {
  return (
    <RichTextImageContainer
      {...otherProps}
      justifyDesktop={justifyDesktop}
      justifyMobile={justifyMobile}
    >
      <Styles {...styles}>
        <WebsiteImage
          src={src}
          alt={alt}
          className="rich-text-image--image"
          style={{ bottom: 0, right: 0, height: 'inherit' }}
          maxWidth="100%"
          widthMobile={widthMobile}
          widthDesktop={widthDesktop}
          imageSizes={imageSizes}
          boxShadow={boxShadow}
        />
      </Styles>
      {caption && caption.length > 0 && <p className="rich-text-image--caption">{caption}</p>}
    </RichTextImageContainer>
  );
};

export default RichTextImage;
